/* eslint-disable */
import React, { Component } from "react";
import {
  Editable,
  EditableInput,
  EditablePreview,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Input,
  Radio,
  RadioGroup,
  Select,
} from "@chakra-ui/react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connectModal } from "redux-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { createUser } from "../../utils/store/actions/users.actions";
import "react-toastify/dist/ReactToastify.css";
import { autoFillUser, SALES_ROLES } from "../../views/Users/User";
import { SubRole } from "../../entities/enums/SubRole";
import { sortAlphabetically } from "../../utils/entities/translation/translation.service";

const isV4Available = (userProperties: any) => {
  return userProperties &&
  userProperties.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      ).value === "true"
};

class ModalCreateUsers extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      preview: false,
      user: {
        firstName: "",
        name: "",
        email: "",
        internal: false,
        language: "fr",
        role: "",
        subRole: "",
      },
      toast: false,
    };
  }

  componentDidMount(): void {
    const defaultRole = isV4Available(this.props.Users.get_properties)
      ? "OPERATOR"
      : "SALES";

    this.setState({
      user: {
        ...this.state.user,
        role: defaultRole,
      },
    });
  }

  handleChange = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;
    this.setState({
      user: autoFillUser({
        ...this.state.user,
        [id]: value,
      }),
    });
  };
  handleChangeRadio = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;
    this.setState({
      user: autoFillUser({
        ...this.state.user,
        [id]: value === "true"
      }),
    });
  };

  handleCreate = () => {
    this.setState({ preview: !this.state.preview });
  };

  create = () => {
    this.props.createUser(autoFillUser(this.state.user)).then(this.props.handleHide);
  };

  render() {
    const { show, handleHide, Users, t } = this.props;
    const { get_properties } = Users;

    let userRoleOptions: Array<string>;
    let userSubRoleOptions: Array<string> = [SubRole.INITIATOR, SubRole.DISTRIBUTOR];
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );

    if (isV4Available(get_properties)) {
      userRoleOptions = ["SALES", "OPERATOR", "DEPOSITARY"];
    } else {
      if (this.props.LocalUser.me.role === "SUPERVISOR") {
        userRoleOptions = [
          "SALES",
          "ANALYST",
          "MANAGER",
          "ADMINISTRATOR",
          "DEPOSITARY",
          "SUPERVISOR",
        ];
      } else {
        userRoleOptions = [
          "SALES",
          "ANALYST",
          "MANAGER",
          "ADMINISTRATOR",
          "DEPOSITARY",
        ];
      }
    }

    return (
      <div>
        <Modal
          isOpen={show}
          toggle={handleHide}
          backdrop={true}
          style={{
            top: "10vh",
            backgroundColor: "rgb(244, 244, 244)",
          }}
        >
          <ModalHeader
            toggle={handleHide}
            close={closeBtn}
            style={{
              backgroundColor: "rgb(244, 244, 244)",
            }}
          >
            {t("CREATE_USER")}
          </ModalHeader>
          <ModalBody
            style={{
              backgroundColor: "rgb(244, 244, 244)",
            }}
          >
            {!this.state.preview ? (
              <Grid
                h="100%"
                templateRows="repeat(5, 1fr)"
                templateColumns="repeat(2, 1fr)"
                gap={2}
              >
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl id="email" isRequired>
                    <FormLabel>{t("EMAIL")}</FormLabel>
                    <Input
                      bg="white"
                      type="email"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={1}>
                  <FormControl id="firstName" isRequired>
                    <FormLabel>{t("FIRST_NAME")}</FormLabel>
                    <Input
                      bg="white"
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={1}>
                  <FormControl id="name" isRequired>
                    <FormLabel>{t("NAME")}</FormLabel>
                    <Input
                      bg="white"
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl
                    id="internal"
                    isRequired
                    // onChange={(e) => {
                    //   this.handleChangeRadio(e);
                    // }}
                  >
                    <FormLabel>{t("INTERNAL")}</FormLabel>
                    <RadioGroup>
                      <HStack spacing="24px">
                        <Radio
                          id="internal"
                          onChange={(e) => {
                            this.handleChangeRadio(e);
                          }}
                          value="true"
                        >
                          {t("YES")}
                        </Radio>
                        <Radio
                          id="internal"
                          onChange={(e) => {
                            this.handleChangeRadio(e);
                          }}
                          value="false"
                        >
                          {t("NO")}
                        </Radio>
                      </HStack>
                    </RadioGroup>
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl id="language" isRequired>
                    <FormLabel>{t("LANGUAGE")}</FormLabel>
                    <Select
                      bg="white"
                      onChange={(e) => this.handleChange(e)}
                      value={this.state.user.language}
                    >
                      <option value="en">{t("ENGLISH")}</option>
                      <option value="fr">{t("FRENCH")}</option>
                      <option value="it">{t("ITALIAN")}</option>
                      <option value="es">{t("SPANISH")}</option>
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl id="role" isRequired>
                    <FormLabel>{t("ROLE")}</FormLabel>
                    <Select
                      bg="white"
                      onChange={(e) => this.handleChange(e)}
                      value={this.state.user.role}
                    >
                      {userRoleOptions &&
                        userRoleOptions.map((option) => (
                          <option value={option}>{t(option)}</option>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                {SALES_ROLES.includes(this.state.user.role) &&
                  this.state.user.internal?.toString() === "false" && (
                    <GridItem rowSpan={1} colSpan={2}>
                      <FormControl id="subRole" isRequired>
                        <FormLabel>{t("SUB_ROLE")}</FormLabel>
                        <Select
                          bg="white"
                          onChange={(e) => this.handleChange(e)}
                          value={this.state.user.subRole}
                        >
                          {userSubRoleOptions
                            ?.sort((a, b) => sortAlphabetically(a, b, t))
                            .map((option) => (
                              <option value={option}>{t(option)}</option>
                            ))}
                        </Select>
                      </FormControl>
                    </GridItem>
                  )}
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl
                    id="isPersonUser"
                    isRequired
                    onChange={(e) => this.handleChange(e)}
                  >
                    <FormLabel>is Person User</FormLabel>
                    <RadioGroup>
                      <HStack spacing="24px">
                        <Radio value="true">Yes</Radio>
                        <Radio value="false">No</Radio>
                      </HStack>
                    </RadioGroup>
                  </FormControl>
                </GridItem>
              </Grid>
            ) : (
              <Grid
                h="100%"
                templateRows="repeat(5, 1fr)"
                templateColumns="repeat(2, 1fr)"
                gap={2}
              >
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl id="email">
                    <FormLabel bg="#E0E1EE">{t("EMAIL")}</FormLabel>
                    <Editable
                      marginLeft={"2vh"}
                      defaultValue={this.state.user.email}
                    >
                      <EditablePreview />
                      <EditableInput />
                    </Editable>
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={1}>
                  <FormControl id="name">
                    <FormLabel bg="#E0E1EE">{t("NAME")}</FormLabel>
                    <Editable
                      marginLeft={"2vh"}
                      defaultValue={this.state.user.name}
                    >
                      <EditablePreview />
                      <EditableInput />
                    </Editable>
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={1}>
                  <FormControl id="firstName">
                    <FormLabel bg="#E0E1EE">{t("FIRST_NAME")}</FormLabel>
                    <Editable
                      marginLeft={"2vh"}
                      defaultValue={this.state.user.firstName}
                    >
                      <EditablePreview />
                      <EditableInput />
                    </Editable>
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl id="internal">
                    <FormLabel bg="#E0E1EE">{t("INTERNAL")}</FormLabel>
                    <Editable
                      marginLeft={"2vh"}
                      defaultValue={t(this.state.user.internal ? "YES" : "NO")}
                    >
                      <EditablePreview />
                      <EditableInput />
                    </Editable>
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl id="role">
                    <FormLabel bg="#E0E1EE">{t("ROLE")}</FormLabel>
                    <Editable
                      marginLeft={"2vh"}
                      defaultValue={t(this.state.user.role)}
                    >
                      <EditablePreview />
                      <EditableInput />
                    </Editable>
                  </FormControl>
                </GridItem>
                <GridItem rowSpan={1} colSpan={2}>
                  <FormControl id="subRole">
                    <FormLabel bg="#E0E1EE">{t("SUB_ROLE")}</FormLabel>
                    <Editable
                      marginLeft={"2vh"}
                      defaultValue={t(this.state.user.subRole)}
                    >
                      <EditablePreview />
                      <EditableInput />
                    </Editable>
                  </FormControl>
                </GridItem>
              </Grid>
            )}
          </ModalBody>
          <ModalFooter
            style={{
              backgroundColor: "rgb(244, 244, 244)",
            }}
          >
            {!this.state.preview ? (
              <>
                <Button
                  style={{ backgroundColor: "#AE0064", color: "#ffff" }}
                  onClick={() => this.handleCreate()}
                >
                  {t("NEXT")}
                </Button>
              </>
            ) : (
              <>
                <Button
                  color="secondary"
                  onClick={() => this.handleCreate()}
                >
                  {t("BACK")}
                </Button>
                <Button
                  style={{ backgroundColor: "#AE0064", color: "#ffff" }}
                  onClick={this.create}
                  disabled={
                    this.state.user.email === "" ||
                    this.state.user.name === "" ||
                    this.state.user.firstName === "" ||
                    this.state.user.internal === "" ||
                    this.state.user.language === "" ||
                    this.state.user.role === ""
                  }
                >
                  {t("DONE")}
                </Button>
              </>
            )}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  createUser,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(connectModal({ name: "create_user" })(ModalCreateUsers)));
